




import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  CoinflowPurchaseProps,
  getWalletPubkey,
  getHandlers,
  CoinflowUtils,
} from './lib/common';
import CoinflowIFrame from './CoinflowIFrame.vue';

@Component({
  components: { CoinflowIFrame },
})
export default class CoinflowPurchase extends Vue {
  @Prop({ required: true, type: Object }) args!: CoinflowPurchaseProps;

  get iframeProps() {
    const walletPubkey = getWalletPubkey(this.args);
    return {
      ...this.args,
      walletPubkey,
      route: `/purchase/${this.args.merchantId}`,
      transaction: CoinflowUtils.getTransaction(this.args),
    };
  }

  get messageHandlers() {
    return {
      ...getHandlers(this.args),
      handleHeightChange: this.args.handleHeightChange,
    };
  }
}
